/**
 * Formato de cifras del dashboard (es-ES)
 */

export function formatNumber(value: number): string {
  return value.toLocaleString('es-ES');
}

export function formatEuros(cents: number): string {
  return (cents / 100).toLocaleString('es-ES', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  });
}

/**
 * Variación porcentual frente al periodo anterior.
 * Devuelve null cuando el periodo anterior vale 0 (no hay base para comparar).
 */
export function percentChange(current: number, previous: number): number | null {
  if (previous === 0) return null;
  return Math.round(((current - previous) / previous) * 100);
}
